module.exports = __webpack_public_path__ + "static/Hwaling_logo-448bed9d17c6d70ef34fa66546132990.png";